module.exports = __webpack_public_path__ + "img/monitorBoxBG.aab1756e.png";